import React from 'react';

export const HeaderLogo = (): React.ReactElement => {
  return (
    <picture>
      <source srcSet="/logo-header.png 1x, /logo-header@2x.png 2x, /logo-header@3x.png 3x" />
      <img src="/logo-header.png" />
    </picture>

  );
}

export const LargeLogo = (): React.ReactElement => {
  return (
    <picture>
      <source srcSet="/logo-large.png 1x, /logo-large@2x.png 2x, /logo-large@3x.png 3x" />
      <img src="/logo-large.png" />
    </picture>

  );
}

export const Logo = (): React.ReactElement => {
  return (
    <picture>
      <source srcSet="/logo.png 1x, /logo@2x.png 2x, /logo@3x.png 3x" />
      <img src="/logo.png" />
    </picture>

  );
}

